import React from "react";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";

// Views
import PrivateRoutes from './PrivateRoutes';
import { ProcessDiagram } from "../features/process/process";
import {
    AllMAp,
    AuthView,
    CreateProcessView,
    DashboardView,
    Error404View,
    GroupOfProcessViewAll,
    DataCollectCreateView,
    CollectDataWorkspaceView,
    CollectDataSynthesisView,
    CollectContributorPage,
    CollectSharedResponderPage,
    CollectRecipientPreviewPage,
    LoginView,
    MailVerification,
    ProcessInterviewView,
    Home,
    ProcessViewAll,
    PrivacyPolicy,
    ResetPasswordView,
    ResetLastPasswordView,
    SiginView,
    ReferralView,
    NewGroupOfProcessView,
    Faq,
    ContactUs,
    CompanyCreateView,
    AdminOnboardingView,
    OutlookPromoOnboardingView,
    ProcessByFolderView,
    TermsAndCondition,
    OautView,
    STDedicatedView,
    DashboardViews,
    UsersView,
    OwnerView,
    AdminView,
    CollaboratorsView,
    DashProcessView,
    CheckMailBox,
    InvitePage,
    ReferralSurveyScreenView,
    ProcessView,
    AnalysisView,
    CompanyAnalysis,
    CampaignsView,
    PricingView
} from "../views";
import { PaymentSuccessView, PaymentCancelView, CustomPaymentSuccessView } from "../views/payment";
import { AuthGuard, STGuard } from "../utils";
import ModernDashboardView from '../views/dashbord/ModernDashboardView';
import ModernInterviewView from '../views/interview/ModernInterviewView';
import MicrosoftPurchaseLanding from '../views/microsoft/MicrosoftPurchaseLanding';
import { OfficeFunctionFileEntry, OfficeSidebarEntry, OfficeHandoffLanding, OfficeAuthDialogEntry, OfficeStAuthDialogEntry, OfficeEmailAuthDialogEntry } from '../views/microsoft/office';
import { AndonHub, AndonDetail } from '../views/andon';
import MicrosoftIntegrationsView from '../views/microsoft/integrations/MicrosoftIntegrationsView';
import TeamsMapTab from '../views/microsoft/teams/TeamsMapTab';
import TeamsMapViewer from '../views/microsoft/teams/TeamsMapViewer';


const NavigationApp = createBrowserRouter(
    createRoutesFromElements(
        <Route errorElement={<Error404View />}>
            <Route path="/" element={<AuthGuard component={AuthView} />} />
            <Route path="/google" element={<OautView />} />
            <Route path="/st-portal" element={<STDedicatedView />} />
            <Route path="/auth">
                <Route path="login" element={<STGuard component={LoginView} />} />
                <Route path="signup" element={<STGuard component={SiginView} />} />
                <Route path="referral" element={<ReferralView />} />
                <Route path="mail" element={<MailVerification />} />
                <Route path="reset-password" element={<ResetPasswordView />} />
                <Route path="reset" element={<ResetLastPasswordView />} />
                <Route path="email-verification" element={<CheckMailBox />} />
            </Route>
            <Route path="/home" element={<AuthGuard component={DashboardView} />} />
            <Route path="/home2" element={<AuthGuard component={ModernDashboardView} />} />

            <Route path="/Privacy_Policy" element={<PrivacyPolicy />} />
            <Route path="/terms_and_conditions" element={<TermsAndCondition />} />
            <Route path="/faq" element={<AuthGuard component={Faq} />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/pricing" element={<AuthGuard component={PricingView} />} />
            <Route path="/r/c/:collectionToken" element={<CollectSharedResponderPage />} />
            <Route path="/r/:token" element={<CollectContributorPage />} />
            
            {/* Microsoft Marketplace Landing Page */}
            <Route path="/microsoft-purchase" element={<AuthGuard component={MicrosoftPurchaseLanding} />} />
            
            {/* Office Add-in Sidebar (taskpane) - no AuthGuard, uses MSAL from Office */}
            <Route path="/embedded/sidebar" element={<OfficeSidebarEntry />} />
            <Route path="/embedded/office-auth" element={<OfficeAuthDialogEntry />} />
            <Route path="/embedded/office-st-auth" element={<OfficeStAuthDialogEntry />} />
            <Route path="/embedded/office-email-auth" element={<OfficeEmailAuthDialogEntry />} />

            {/* Teams embed surfaces (PRD §5.5) */}
            <Route path="/embedded/teams/map-tab" element={<TeamsMapTab />} />
            <Route path="/embedded/teams/map-viewer" element={<TeamsMapViewer />} />

            {/* Office Commands FunctionFile - must not 404 (Outlook validates this URL) */}
            <Route path="/office/functions.html" element={<OfficeFunctionFileEntry />} />

            {/* Office handoff landing (PRD alias) */}
            <Route path="/map/new" element={<AuthGuard component={OfficeHandoffLanding} />} />
            
            {/* Payment Routes */}
            <Route path="/payment-success" element={<AuthGuard component={PaymentSuccessView} />} />
            <Route path="/payment-success/custom" element={<CustomPaymentSuccessView />} />
            <Route path="/payment-cancel" element={<AuthGuard component={PaymentCancelView} />} />
            <Route element={<PrivateRoutes />}>
                <Route path="/process">
                    <Route path="data-collect/create" element={<AuthGuard component={DataCollectCreateView} />} />
                    <Route path="data-collect/:collectionId/recipient-preview" element={<AuthGuard component={CollectRecipientPreviewPage} />} />
                    <Route path="data-collect/:collectionId" element={<AuthGuard component={CollectDataWorkspaceView} />} />
                    <Route path="data-collect/:collectionId/synthesis" element={<AuthGuard component={CollectDataSynthesisView} />} />
                    <Route path="create/:typ" element={<CreateProcessView />} />
                    <Route path="create" element={<CreateProcessView />} />
                    <Route path="createGroup" element={<NewGroupOfProcessView />} />
                    {/* <Route path="interviews/:id" element={<AuthGuard component={ProcessInterviewView} />} /> */}
                    <Route path="interviews/:id" element={<AuthGuard component={ModernInterviewView} />} />
                    <Route path="overview" element={<AuthGuard component={Home} />} />
                    <Route path="library" element={<AuthGuard component={ProcessView} />} />
                    <Route path="analysis" element={<AuthGuard component={AnalysisView} />} />
                    <Route path="my/processes" element={<AuthGuard component={ProcessViewAll} />} />
                    <Route path="folder" element={<AuthGuard component={GroupOfProcessViewAll} />} />
                    <Route path="all" element={<AuthGuard component={AllMAp} />} />
                    <Route path="mapping/:id/:sId" element={<AuthGuard component={ProcessDiagram} />} />
                    <Route path="mapping/:id/:sId/:AnalyseId" element={<AuthGuard component={ProcessDiagram} />} />
                    <Route path="folder/:id" element={<AuthGuard component={ProcessByFolderView} />} />
                </Route>
            </Route>
            <Route element={<PrivateRoutes />}>
                <Route path="/dashboard">
                    <Route path="home" element={<AuthGuard component={DashboardViews} />} />
                    <Route path="collaborators" element={<CollaboratorsView />} />
                    <Route path="users" element={<UsersView />} />
                    <Route path="owner" element={<OwnerView />} />
                    <Route path="admin" element={<AdminView />} />
                    <Route path="process" element={<DashProcessView />} />
                    <Route path="andon" element={<AuthGuard component={AndonHub} />} />
                    <Route path="andon/:id" element={<AuthGuard component={AndonDetail} />} />
                    <Route path="microsoft-integrations" element={<AuthGuard component={MicrosoftIntegrationsView} />} />
                </Route>
            </Route>
            <Route element={<PrivateRoutes />}>
                <Route path="/company">
                    <Route path="create" element={<AuthGuard component={CompanyCreateView} />} />
                    <Route path="onboarding" element={<AuthGuard component={AdminOnboardingView} />} />
                    <Route path="outlook-promo" element={<AuthGuard component={OutlookPromoOnboardingView} />} />
                    <Route path="analysis" element={<AuthGuard component={CompanyAnalysis} />} />
                    <Route path="analysis/:analysisId" element={<AuthGuard component={CompanyAnalysis} />} />
                    <Route path="invited/:from" element={<AuthGuard component={InvitePage} />} />
                    <Route path="referral-survey" element={<AuthGuard component={ReferralSurveyScreenView} />} />
                </Route>
            </Route>
            <Route path="/campaigns" element={<AuthGuard component={CampaignsView} />} />
            {/* <Route path="/company/create" element={<AuthGuard component={CompanyCreateView} />} /> */}
            <Route path="*" element={<Error404View />} />
        </Route>
    )
);

export default NavigationApp;
